import c from '../common';

export default{
    "description_phone": "Phone number: ",
    "description_Prule1": "Please enter phone number",
    "description_Prule2": "Phone number can only be Arabic numerals.",
    "description_Prule3": "Phone number cannot contain space.",

    "Password": "Password: ",
    "Pw_requirement": "Please enter 9-16 password",

    "Wrong-index-1": "email / password incorrect. Please Re-Type.",
    "re-enter": "OK",

    "NA1": "You do not have permission to access the portal",

    "Login": "Login",
    "Register": "Sign Up",
    "Forgot": "Forgot Password",

    "V-Code": c.V_Code.en,

    "PinWrong": "The Pin entered is incorrect.",

    "back": c.Back.en,
    "confirm": c.Confirm.en,

    "6digit": "Please enter 6 digit numbers.",
    "Only6": "Please enter only numbers.",

    "description_1": c.BBS_title.en,
    "description_2": "Invalid mobile number",

};